import React from 'react'
import { formatPhone } from '../../assignment/components/common/AssignmentUtils'

const BusinessContactInformation = ({ appraiserInfo }) =>
  <div className='appraiser-business-contact-info'>
    <h3>Business Contact Information</h3>
    {appraiserInfo.fetching && <div className='loading'>Loading...</div>}
    {appraiserInfo && !appraiserInfo.error && !appraiserInfo.fetching &&
      <table>
        <tbody>
          <tr>
            <th scope='row'>Address</th>
            <td>
              {appraiserInfo.addressOne}<br />
              {appraiserInfo.addressTwo && <span>&nbsp;{appraiserInfo.addressTwo}<br /></span>}
              {appraiserInfo.addressThree && <span>&nbsp;{appraiserInfo.addressThree}<br /></span>}
              &nbsp;{appraiserInfo.cityName}, {appraiserInfo.state}
              &nbsp;{appraiserInfo.zipPrefixNumber}{appraiserInfo.zipFirstSuffix ? '-' + appraiserInfo.zipFirstSuffix : ''}
            </td>
          </tr>
          <tr>
            <th scope='row'>Rep Code</th>
            <td>{appraiserInfo.repCode}</td>
          </tr>
          <tr>
            <th scope='row'>Email</th>
            <td>{appraiserInfo.email}</td>
          </tr>
          <tr>
            <th scope='row'>Work Phone</th>
            <td>{formatPhone(appraiserInfo.phone)}{appraiserInfo.phoneExt ? ' Ext. ' + appraiserInfo.phoneExt : ''}</td>
          </tr>
          <tr>
            <th scope='row'>Cell Phone</th>
            <td>{formatPhone(appraiserInfo.cellPhone)}</td>
          </tr>
          <tr>
            <th scope='row'>Home Phone</th>
            <td>{formatPhone(appraiserInfo.homePhone)}</td>
          </tr>
          <tr>
            <th scope='row'>Fax</th>
            <td>{formatPhone(appraiserInfo.fax)}</td>
          </tr>
        </tbody>
      </table>}
    {appraiserInfo.error && !appraiserInfo.fetching &&
      <div>Error: Unable to load business contact information.</div>}
  </div>

export default BusinessContactInformation
